<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-6">
            <a @click="openPage('/sales')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateChangePass('changePassForm')" data-vv-scope="changePassForm">
              <div class="mb-10">
                <input type="password" v-model="changePassData.old_password" placeholder="Current Password" class="w-100" v-validate="'required'" name="current_password">
                <span class="error">{{ errors.first('changePassForm.current_password') }}</span>
              </div>
              <div class="mb-10">
                <input ref="pw_confirm" v-model="changePassData.new_password" type="password" placeholder="New Password" class="w-100" v-validate="'required'" name="new_password">
                <span class="error">{{ errors.first('changePassForm.new_password') }}</span>
              </div>
              <div class="mb-10">
                <input type="password" v-model="changePassData.confirm_password" placeholder="Confirm New Password" class="w-100" v-validate="'required|confirmed:pw_confirm'" name="confirm_new_password">
                <span class="error">{{ errors.first('changePassForm.confirm_new_password') }}</span>
              </div>
              <div class="text-right">
                <button type="submit" class="btn-primary">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'change-password',
  data: function () {
    return {
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },
  mounted () {
    let roleId = localStorage.getItem('paradigm_role')
    if (roleId == '4' || roleId == '3') {
      this.$router.push('/sales/edit?id=' + Auth.Session.get().paradigm_id)
    } else if (roleId == '1' || roleId == '2') {
      this.$router.push('/admin/edit?id=' + Auth.Session.get().paradigm_id)
    } else if (roleId == '6') {
      this.$router.push('/customerService/edit?id=' + Auth.Session.get().paradigm_id)
    }
  },
  methods: {
    async validateChangePass (scope) {

      let isValidate = await this.$validator.validateAll(scope)
      if (!isValidate) {
        this.$toast.success('please fill in required fields!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return
      }

      let result

      try {
        let id = localStorage.getItem('paradigm_user_id')
        result = await axios.put('vendor/v1/user/change_password/' + id, this.changePassData)
        this.$toast.success('data saved successfully!', 'Success', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        this.$router.push('/')
      } catch (error) {
        let message = error.response.data.error || 'cant saved data!'
        this.$toast.success(message, 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      }
    }
  }
}
</script>

<style>
</style>
